import React from 'react';
import { services } from '../mockData';
import { 
  Tv, TrendingUp, MessageSquare, FileText, Sparkles, 
  Users, Globe, Brain, Linkedin, Radio 
} from 'lucide-react';

const iconMap = {
  Tv, TrendingUp, MessageSquare, FileText, Sparkles,
  Users, Globe, Brain, Linkedin, Radio
};

const Services = () => {
  return (
    <div className="page-container">
      {/* Services Hero */}
      <section className="services-hero-section">
        <div className="container">
          <h1 className="heading-1">OUR SERVICES</h1>
          <p className="body-large max-w-4xl">
            Comprehensive solutions across Media, Marketing, Communication, Content, Branding, 
            PR, Digital, and AI Consulting. We deliver integrated, outcome-driven ecosystems 
            tailored to your business needs.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div key={service.id} className="service-card">
                  <div className="service-icon">
                    {IconComponent && <IconComponent size={32} />}
                  </div>
                  <h3 className="heading-5">{service.title}</h3>
                  <p className="body-small">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section-padding bg-card">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">WHY CHOOSE VAIKUNTHA MEDIA</h2>
          <div className="why-choose-grid">
            <div className="why-choose-item">
              <h3 className="heading-5">Integration-Driven Solutions</h3>
              <p className="body-small">
                We bridge integration gaps across media, technology, communication, and 
                strategy to deliver holistic solutions that drive real business outcomes.
              </p>
            </div>
            <div className="why-choose-item">
              <h3 className="heading-5">Data & Technology Backbone</h3>
              <p className="body-small">
                Every solution is supported by robust data analytics and cutting-edge 
                technology infrastructure managed by specialized experts.
              </p>
            </div>
            <div className="why-choose-item">
              <h3 className="heading-5">Multifaceted Industry Exposure</h3>
              <p className="body-small">
                Experience across Government, Consumer Markets, and Knowledge-Intensive 
                industries with proven track record in diverse sectors.
              </p>
            </div>
            <div className="why-choose-item">
              <h3 className="heading-5">Global & Local Expertise</h3>
              <p className="body-small">
                Founded by industry experts from India and abroad, combining global 
                perspectives with deep local market understanding.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Approach */}
      <section className="section-padding">
        <div className="container">
          <div className="approach-content">
            <h2 className="heading-2">OUR APPROACH TO SERVICES</h2>
            <div className="approach-grid">
              <div className="approach-item">
                <div className="approach-number">01</div>
                <h3 className="heading-5">Strategic Foundation</h3>
                <p className="body-small">
                  Every service begins with deep strategic analysis, understanding your 
                  business objectives and target audience dynamics.
                </p>
              </div>
              <div className="approach-item">
                <div className="approach-number">02</div>
                <h3 className="heading-5">Integrated Execution</h3>
                <p className="body-small">
                  Services are delivered in coordination, ensuring seamless integration 
                  across all communication and technology touchpoints.
                </p>
              </div>
              <div className="approach-item">
                <div className="approach-number">03</div>
                <h3 className="heading-5">Measurable Outcomes</h3>
                <p className="body-small">
                  Data-driven tracking and optimization ensure every service delivers 
                  quantifiable results aligned with your business goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-2">LET'S BUILD YOUR SOLUTION</h2>
            <p className="body-large">
              Schedule a consultation to discuss how our services can drive your business forward.
            </p>
            <a href="/contact" className="btn-primary btn-large">
              Get Started
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
